import React from "react";
import moment from "moment";
import { BodyBuilder } from "../../exports/Images";
import {
  convertStraight,
  convertThenFormat,
  convertTime,
  convertTo12HourFormat,
  formatDateTimezon,
} from "../common-data/Converts";
import {
  PT_TRIAL_INLINE_LUNGE__TEST,
  PT_TRIAL_LEG_RAISE_TEST,
  PT_TRIAL_OVERALL_FITNESS_RATING,
  PT_TRIAL_PLANK_TEST,
  PT_TRIAL_PUSHUP_TEST,
  PT_TRIAL_RUN_TEST,
  PT_TRIAL_SHOULDER_EXTENSION_TEST,
  PT_TRIAL_SHOULDER_FLEXION_TEST,
  PT_TRIAL_THOMAS_TEST,
} from "../common-data/DropdowData";
import { getTestLabel } from "./common/SharedDatas";
import {
  EmailIcon,
  CallIcon,
  CalendarIcon,
  LocationIcon,
  ClockIconV3,
  WorkoutIcon,
  ScaleIcon,
  DownloadIcon,
  CheckCircleIcon,
  XCircleIcon,
  GenderIcon,
  TrainerIcon1,
} from "../../images/icons/icons";
import "../../styles/common/tme-member-profile.css";

const UserProfile = ({ userData }) => {
  const shiftTimings = userData?.assigned_to_shift?.map((shift) => {
    const startTime = shift?.start_time
      ? moment(shift.start_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
      : "";
    const endTime = shift?.end_time
      ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
      : "";
    return `${startTime}-${endTime}`;
  });

  const shiftTiming = shiftTimings
    ? shiftTimings?.join(", ")
    : "No Shift Found";

  const type = userData?.prspct_status || "";

  return (
    <div className="user-profile-container">
      <>
        {/* <div className="flexCol">
        <div className="user-profile-img">
          <img
            src={userData?.user_profile_new || BodyBuilder}
            alt={userData?.user_name || ""}
            className="user-image"
          />

          <p className="info-name" style={{ flexDirection: "column" }}>
            {userData?.user_name || "NA"}
            <br />
            <>
              {userData?.isfitness_profile_completed === "completed" &&
              userData?.is_biomax_registered === "true" ? (
                <span className="profile-name-attached-icon green">
                  Biomax Registered | Fitness Profile Completed!
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-all"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486z" />
                  </svg>
                </span>
              ) : userData?.isfitness_profile_completed === "completed" ? (
                <span className="profile-name-attached-icon fitness-profile green">
                  Fitness Profile Completed!
                </span>
              ) : userData?.is_biomax_registered === "true" ? (
                <span className="profile-name-attached-icon biomax-status green">
                  Biomax Registered!
                </span>
              ) : (
                <span className="profile-name-attached-icon green">
                  Biomax Not Registered and Fitness Profile Pending!
                  <CrossCircleIcon />
                </span>
              )}
            </>
          </p>

          <p className="info-name" style={{ textDecoration: "underline" }}>
            {userData?.user_mobile || "NA"}
          </p>

          <p
            className="info-name"
            style={{
              textTransform: `${
                userData?.user_email ? "lowercase" : "capitialize"
              }`,
              textDecoration: "underline",
            }}
          >
            {userData?.user_email || "NA"}
          </p>

          <p className="info-name">{userData?.gym_name || "NA"}</p>

          <p className="info-name">
            Last Checkin Date/Time{" "}
            {userData?.last_checkin
              ? formatDateTimezon(userData.last_checkin)
              : "-"}{" "}
            {userData?.checkin_time
              ? `(${convertTime(userData.checkin_time)})`
              : ""}
          </p>

          <p className="info-name">
            Last Workout{" "}
            {userData?.last_workout_date
              ? formatDateTimezon(userData.last_workout_date)
              : "-"}
          </p>
        </div>

        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">handover status</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name"
                style={{
                  background:
                    userData?.handover_status === "handover_converted"
                      ? "#E2EFD5"
                      : userData?.handover_status === "completed" ||
                        userData?.handover_status === "handover_completed"
                      ? "#FFEDC0"
                      : "#F3DADA",
                  color:
                    userData?.handover_status === "converted"
                      ? "#379C00"
                      : userData?.handover_status === "completed" ||
                        userData?.handover_status === "handover_completed"
                      ? "#171717"
                      : "#D90000",
                  padding: "10px",
                  borderRadius: "16px",
                }}
              >
                {userData?.handover_status?.replace(/_/g, " ") || "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">trial status</p>
            </div>
            <div className="user-details-info">
              <p
                className="info-name"
                style={{
                  background:
                    userData?.trial_status === "converted"
                      ? "#E2EFD5"
                      : userData?.trial_status === "completed"
                      ? "#FFEDC0"
                      : "#F3DADA",
                  color:
                    userData?.trial_status === "converted"
                      ? "#379C00"
                      : userData?.trial_status === "completed"
                      ? "#171717"
                      : "#D90000",
                  padding: "10px",
                  borderRadius: "16px",
                }}
              >
                {userData?.trial_status === "completed"
                  ? "Completed (Not Converted)"
                  : userData?.trial_status === "trial_done_cnvrtd"
                  ? "PT consultation done And Converted"
                  : userData?.trial_status === "trial_notdone_cnvrtd"
                  ? "PT consultation not done And Converted"
                  : userData.trial_status?.replace(/_/g, " ") || "NA"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">BCA Report</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.bca_report ? (
                  <button type="button" className="actionBtn icon download">
                    <a href={userData?.bca_report}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-cloud-arrow-down"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            userData?.trial_status === "pending"
                              ? "gray"
                              : "#CD0909",
                          minWidth: "35px",
                          minHeight: "35px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                        />
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                      </svg>
                    </a>
                  </button>
                ) : (
                  "Not Available"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Member Pre Assesment Chart</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.assessment_doc ? (
                  <button type="button" className="actionBtn icon download">
                    <a href={userData?.assessment_doc}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-cloud-arrow-down"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            userData?.trial_status === "pending"
                              ? "gray"
                              : "#CD0909",
                          minWidth: "35px",
                          minHeight: "35px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                        />
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                      </svg>
                    </a>
                  </button>
                ) : (
                  "Not Available"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Member Profile</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.profile_doc ? (
                  <button type="button" className="actionBtn icon download">
                    <a href={userData?.profile_doc}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-cloud-arrow-down"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            userData?.trial_status === "pending"
                              ? "gray"
                              : "#CD0909",
                          minWidth: "35px",
                          minHeight: "35px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                        />
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                      </svg>
                    </a>
                  </button>
                ) : (
                  "Not Available"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Fitness Consultation (Page 1)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.ftns_cnsltnt_doc1 ? (
                  <button type="button" className="actionBtn icon download">
                    <a href={userData?.ftns_cnsltnt_doc1}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-cloud-arrow-down"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            userData?.trial_status === "pending"
                              ? "gray"
                              : "#CD0909",
                          minWidth: "35px",
                          minHeight: "35px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                        />
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                      </svg>
                    </a>
                  </button>
                ) : (
                  "Not Available"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Fitness Consultation (Page 2)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.ftns_cnsltnt_doc2 ? (
                  <button type="button" className="actionBtn icon download">
                    <a href={userData?.ftns_cnsltnt_doc2}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-cloud-arrow-down"
                        viewBox="0 0 16 16"
                        style={{
                          color:
                            userData?.trial_status === "pending"
                              ? "gray"
                              : "#CD0909",
                          minWidth: "35px",
                          minHeight: "35px",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                        />
                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                      </svg>
                    </a>
                  </button>
                ) : (
                  "Not Available"
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Trainer Intro</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.trnr_intro_status === "completed" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <CrossCircleIcon />
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">PT Prospect</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.is_pt_prspct ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#E41815", width: "35px", height: "35px" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                  </svg>
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Trainer Intro</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.trnr_intro_status === "completed" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#E41815", width: "35px", height: "35px" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                  </svg>
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">biomax first step (App Register)</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.biomax_first_step === "completed" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#E41815", width: "35px", height: "35px" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                  </svg>
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Biomax Registered</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.is_biomax_registered === "true" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#E41815", width: "35px", height: "35px" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                  </svg>
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name"> Fitness Profile</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {userData?.isfitness_profile_completed === "completed" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                    style={{
                      color: "#209216",
                      width: "35px",
                      height: "35px",
                    }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-x-circle-fill"
                    viewBox="0 0 16 16"
                    style={{ color: "#E41815", width: "35px", height: "35px" }}
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                  </svg>
                )}
              </p>
            </div>
          </div>
        </div>
      </div> */}
      </>

      <div className="flexCol">
        <div className="user-profile-info-card">
          <div className="user-profile-header">
            <div className="user-profile-icon">
              <img
                src={userData?.user_profile_new || BodyBuilder}
                alt={userData?.user_name || "Member"}
                className="user-profile-avatar"
              />
            </div>
            <h2 className="user-profile-name">{userData?.user_name || "NA"}</h2>
          </div>

          <div className="user-profile-details-list">
            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <EmailIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Email</p>
                <p className="user-profile-detail-value lowercase">
                  {userData?.user_email || "NA"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <CallIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Phone</p>
                <p className="user-profile-detail-value">
                  {userData?.user_mobile || "NA"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <GenderIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">gender</p>
                <p className="user-profile-detail-value">
                  {userData?.user_gender || "-"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <CalendarIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">DOB</p>
                <p className="user-profile-detail-value">
                  {userData?.user_birthdate || "-"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <LocationIcon />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">gym name</p>
                <p className="user-profile-detail-value">
                  {userData?.gym_name || "NA"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <ClockIconV3 color="#ec2424" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Last Checked-in</p>
                <p className="user-profile-detail-value">
                  {userData?.last_checkin
                    ? formatDateTimezon(userData.last_checkin)
                    : "-"}{" "}
                  {userData?.checkin_time
                    ? `${convertTime(userData.checkin_time)}`
                    : ""}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <WorkoutIcon color="#ec2424" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Last Workout</p>
                <p className="user-profile-detail-value">
                  {userData?.last_workout_date
                    ? formatDateTimezon(userData.last_workout_date)
                    : "-"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <CalendarIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Join Date</p>
                <p className="user-profile-detail-value">
                  {userData?.regular_start_date
                    ? formatDateTimezon(userData.regular_start_date)
                    : "-"}
                </p>
              </div>
            </div>

            <div className="user-profile-detail-item">
              <div className="user-profile-detail-icon">
                <CalendarIcon color="#6b7280" />
              </div>
              <div className="user-profile-detail-content">
                <p className="user-profile-detail-label">Expiry Date</p>
                <p className="user-profile-detail-value">
                  {userData?.regular_expire_date
                    ? formatDateTimezon(userData.regular_expire_date)
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="user-profile-info-card">
          <div className="user-profile-header">
            <div className="user-profile-icon user-progile-ft-icon">
              <ScaleIcon color="#ec2424" />
            </div>
            <h2 className="user-profile-name">Fitness Profile</h2>
          </div>

          <div className="user-profile-fitness-grid">
            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Height</p>
              <p className="user-profile-fitness-value">
                {userData?.height?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Weight</p>
              <p className="user-profile-fitness-value">
                {userData?.weight?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">target weight</p>
              <p className="user-profile-fitness-value">
                {userData?.target_weight?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">BMI</p>
              <p className="user-profile-fitness-value">
                {userData?.bmi || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Body Fat</p>
              <p className="user-profile-fitness-value">
                {userData?.body_fat ? `${userData.body_fat}%` : "-"}
              </p>
            </div>
          </div>
        </div>

        <div className="user-profile-info-card">
          <div className="user-profile-fitness-grid">
            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">BCA Report</p>
              <p className="user-profile-fitness-value">
                {userData?.bca_report ? (
                  <button type="button" className="actionBtn icon download">
                    <a
                      href={userData.bca_report}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon color="#209216" />
                    </a>
                  </button>
                ) : (
                  "-"
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Pre Assesment Chart</p>
              <p className="user-profile-fitness-value">
                {userData?.assessment_doc ? (
                  <button type="button" className="actionBtn icon download">
                    <a
                      href={userData.assessment_doc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon color="#209216" />
                    </a>
                  </button>
                ) : (
                  "-"
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Member Profile</p>
              <p className="user-profile-fitness-value">
                {userData?.profile_doc ? (
                  <button type="button" className="actionBtn icon download">
                    <a
                      href={userData.profile_doc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon color="#209216" />
                    </a>
                  </button>
                ) : (
                  "-"
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Fitness Consultation (Page 1)
              </p>
              <p className="user-profile-fitness-value">
                {userData?.ftns_cnsltnt_doc1 ? (
                  <button type="button" className="actionBtn icon download">
                    <a
                      href={userData.ftns_cnsltnt_doc1}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon color="#209216" />
                    </a>
                  </button>
                ) : (
                  "-"
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Fitness Consultation (Page 2)
              </p>
              <p className="user-profile-fitness-value">
                {userData?.ftns_cnsltnt_doc2 ? (
                  <button type="button" className="actionBtn icon download">
                    <a
                      href={userData.ftns_cnsltnt_doc2}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon color="#209216" />
                    </a>
                  </button>
                ) : (
                  "-"
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Trainer Intro</p>
              <p className="user-profile-fitness-value">
                {userData?.trnr_intro_status === "completed" ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">PT Prospect</p>
              <p className="user-profile-fitness-value">
                {userData?.is_pt_prspct ? <CheckCircleIcon /> : <XCircleIcon />}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                biomax first step (App Register)
              </p>
              <p className="user-profile-fitness-value">
                {userData?.biomax_first_step === "completed" ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Biomax Registered</p>
              <p className="user-profile-fitness-value">
                {userData?.is_biomax_registered === "true" ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Fitness Profile</p>
              <p className="user-profile-fitness-value">
                {userData?.isfitness_profile_completed === "completed" ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-details user-profile-detailed-info">
        <div className="user-profile-info-card">
          <div className="user-profile-header">
            <div className="user-profile-icon user-progile-ft-icon">
              <TrainerIcon1 color="#ec2424" />
            </div>
            <h2 className="user-profile-name">BCA Trainer</h2>
          </div>

          <div className="user-profile-fitness-grid">
            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Name</p>
              <p className="user-profile-fitness-value">
                {userData?.trainer_name || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Mobile</p>
              <p className="user-profile-fitness-value">
                {userData?.trainer_mobile || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">email</p>
              <p className="user-profile-fitness-value lowercase">
                {userData?.trainer_email || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">shift</p>
              <p className="user-profile-fitness-value">
                {userData?.trainer_name && shiftTiming ? `${shiftTiming}` : "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">last checked-in</p>
              <p className="user-profile-fitness-value">
                {userData?.trainer_name && userData?.assigned_to_last_checkin
                  ? formatDateTimezon(userData.assigned_to_last_checkin)
                  : "-"}{" "}
                {userData?.trainer_name && userData?.assigned_to_checkin_time
                  ? convertTime(userData.assigned_to_checkin_time)
                  : "-"}
              </p>
            </div>
          </div>
        </div>

        <div className="user-profile-info-card">
          <div className="user-profile-fitness-grid">
            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">handover status</p>
              <p
                className="user-profile-fitness-value user-profile-fitness-value-badge"
                style={{
                  background:
                    userData?.handover_status === "handover_converted"
                      ? "#E2EFD5"
                      : userData?.handover_status === "completed" ||
                        userData?.handover_status === "handover_completed"
                      ? "#FFEDC0"
                      : "#F3DADA",
                  color:
                    userData?.handover_status === "converted"
                      ? "#379C00"
                      : userData?.handover_status === "completed" ||
                        userData?.handover_status === "handover_completed"
                      ? "#171717"
                      : "#D90000",
                  padding: "10px",
                  borderRadius: "16px",
                }}
              >
                {userData?.handover_status?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">trial status</p>
              <p
                className="user-profile-fitness-value user-profile-fitness-value-badge"
                style={{
                  background:
                    userData?.trial_status === "converted"
                      ? "#E2EFD5"
                      : userData?.trial_status === "completed"
                      ? "#FFEDC0"
                      : "#F3DADA",
                  color:
                    userData?.trial_status === "converted"
                      ? "#379C00"
                      : userData?.trial_status === "completed"
                      ? "#171717"
                      : "#D90000",
                  padding: "10px",
                  borderRadius: "16px",
                }}
              >
                {userData?.trial_status === "completed"
                  ? "Completed (Not Converted)"
                  : userData?.trial_status === "trial_done_cnvrtd"
                  ? "PT consultation done And Converted"
                  : userData?.trial_status === "trial_notdone_cnvrtd"
                  ? "PT consultation not done And Converted"
                  : userData.trial_status?.replace(/_/g, " ") || "NA"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Member Profession</p>
              <p className="user-profile-fitness-value">
                {userData?.profession?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Subscription Added By
              </p>
              <p className="user-profile-fitness-value">
                {userData?.sub_added_by_name || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Current Plan Name</p>
              <p className="user-profile-fitness-value">
                {userData?.current_plan_name?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Current Plan Duration
              </p>
              <p className="user-profile-fitness-value">
                {userData?.regular_start_date
                  ? formatDateTimezon(userData.regular_start_date)
                  : "-"}{" "}
                /{" "}
                {userData?.regular_expire_date
                  ? formatDateTimezon(userData.regular_expire_date)
                  : "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Payment Location</p>
              <p className="user-profile-fitness-value">
                {userData?.payment_location === "gym"
                  ? "Inside Gym"
                  : userData?.payment_location === "outside"
                  ? "Outside Gym"
                  : "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                member Current Plan status
              </p>
              <p
                className="user-profile-fitness-value user-profile-fitness-value-badge"
                style={{
                  background:
                    userData?.current_plan_status === "active"
                      ? "#E2EFD5"
                      : "#F3DADA",
                  color:
                    userData?.current_plan_status === "active"
                      ? "#379C00"
                      : "#D90000",
                  padding: "10px",
                  borderRadius: "16px",
                }}
              >
                {userData?.current_plan_status || "NA"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">diet preference</p>
              <p className="user-profile-fitness-value">
                {userData?.diet_preference?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">goal</p>
              <p className="user-profile-fitness-value">
                {userData?.user_goal?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">how active</p>
              <p className="user-profile-fitness-value">
                {userData?.how_active?.replace(/_/g, " ") || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">medical history</p>
              <p className="user-profile-fitness-value">
                {userData?.medical_history || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Handover Date</p>
              <p className="user-profile-fitness-value">
                {userData?.assigned_date
                  ? formatDateTimezon(userData.assigned_date)
                  : "-"}{" "}
                {userData?.assigned_date_days_ago
                  ? `(${userData.assigned_date_days_ago?.replace(/_/g, " ")})`
                  : "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Handover by</p>
              <p className="user-profile-fitness-value">
                {userData?.assigned_by_name || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                PT Trial schedule date
              </p>
              <p className="user-profile-fitness-value">
                {userData?.pt_schedule_date
                  ? convertStraight(userData.pt_schedule_date)
                  : "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Assigned To</p>
              <p className="user-profile-fitness-value">
                {userData?.assigned_to_name || "-"}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">3 Day PT Trial</p>
              <p className="user-profile-fitness-value">
                {userData?.three_day_assigned ? (
                  <CheckCircleIcon />
                ) : (
                  <XCircleIcon />
                )}
              </p>
            </div>

            {userData?.three_day_assigned ? (
              <>
                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">
                    3 Day PT Trial duration
                  </p>
                  <p className="user-profile-fitness-value">
                    {userData?.threeday_start_date
                      ? convertStraight(userData.threeday_start_date)
                      : "-"}
                    {" - "}
                    {userData?.threeday_expire_date
                      ? convertStraight(userData.threeday_expire_date)
                      : "-"}
                  </p>
                </div>

                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">
                    3 Day PT Trial slot
                  </p>
                  <p className="user-profile-fitness-value">
                    {userData?.threeday_slot_start
                      ? convertTo12HourFormat(userData.threeday_slot_start)
                      : "-"}{" "}
                    -{" "}
                    {userData?.threeday_slot_end
                      ? convertTo12HourFormat(userData.threeday_slot_end)
                      : "-"}
                  </p>
                </div>
              </>
            ) : null}

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">PT Prospect</p>
              <p className="user-profile-fitness-value">
                {userData?.is_pt_prspct ? <CheckCircleIcon /> : <XCircleIcon />}
              </p>
            </div>

            {userData?.is_pt_prspct ? (
              <>
                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">
                    PT Prospect value
                  </p>
                  <p className="user-profile-fitness-value">
                    ₹{convertThenFormat(userData?.prspct_value || 0)}
                  </p>
                </div>

                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">
                    PT Prospect session
                  </p>
                  <p className="user-profile-fitness-value">
                    {userData?.prspct_session && userData?.prspct_duration
                      ? `(${userData.prspct_session} for ${userData.prspct_duration} days)`
                      : "-"}
                  </p>
                </div>

                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">
                    PT Prospect closure date
                  </p>
                  <p className="user-profile-fitness-value">
                    {userData?.expctd_closure_date
                      ? convertStraight(userData.expctd_closure_date)
                      : "-"}
                  </p>
                </div>

                <div className="user-profile-fitness-item">
                  <p className="user-profile-fitness-label">PT Prospect type</p>
                  <p
                    className="user-profile-fitness-value user-profile-fitness-value-badge"
                    style={{
                      color:
                        type === "hot"
                          ? "#0A6847"
                          : type === "semi hot"
                          ? "#D9610B"
                          : type === "warm"
                          ? "#D78B03"
                          : type === "cold"
                          ? "#157EF9"
                          : "",
                    }}
                  >
                    {type === "closed_not_cnvrtd"
                      ? "Closed and not converted"
                      : type === "closed_cnvrtd_prspct"
                      ? "Closed and converted"
                      : type === "not_specified_prspct"
                      ? "Prospect Not Specified"
                      : type?.replace(/_/g, " ")}
                  </p>
                </div>
              </>
            ) : null}

            {!userData?.is_pt_prspct && userData?.pt_prspct_reason ? (
              <div className="user-profile-fitness-item">
                <p className="user-profile-fitness-label">
                  No PT Prospect reason
                </p>
                <p className="user-profile-fitness-value">
                  {userData.pt_prspct_reason || "-"}
                </p>
              </div>
            ) : null}

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">1 Minute Run Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(PT_TRIAL_RUN_TEST, userData?.min_run_test)}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Push-Up Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(PT_TRIAL_PUSHUP_TEST, userData?.push_up_test)}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Plank Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(PT_TRIAL_PLANK_TEST, userData?.plank_test)}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Wall Sit Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(PT_TRIAL_PLANK_TEST, userData?.wall_sit_test)}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">In-Line Lunge Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(
                  PT_TRIAL_INLINE_LUNGE__TEST,
                  userData?.lunge_test
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Shoulder Flexion Test
              </p>
              <p className="user-profile-fitness-value">
                {getTestLabel(
                  PT_TRIAL_SHOULDER_FLEXION_TEST,
                  userData?.shoulder_flex_test
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Shoulder Extension Test
              </p>
              <p className="user-profile-fitness-value">
                {getTestLabel(
                  PT_TRIAL_SHOULDER_EXTENSION_TEST,
                  userData?.shoulder_extn_test
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Leg Raise Angle</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(
                  PT_TRIAL_LEG_RAISE_TEST,
                  userData?.leg_raise_angle
                )}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">Thomas Test</p>
              <p className="user-profile-fitness-value">
                {getTestLabel(PT_TRIAL_THOMAS_TEST, userData?.thomas_test)}
              </p>
            </div>

            <div className="user-profile-fitness-item">
              <p className="user-profile-fitness-label">
                Overall Fitness Rating
              </p>
              <p className="user-profile-fitness-value">
                {getTestLabel(
                  PT_TRIAL_OVERALL_FITNESS_RATING,
                  userData?.overall_fitness
                )}
              </p>
            </div>
          </div>
        </div>

        <>
          {/* 
            <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Trainer Name</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.trainer_name || "NA"} </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Trainer Mobile</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.trainer_mobile || "NA"}</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Trainer email</p>
          </div>
          <div className="user-details-info">
            <p
              className="info-name"
              style={{
                textTransform: `${
                  userData?.trainer_email ? "lowercase" : "capitialize"
                }`,
              }}
            >
              {userData?.trainer_email || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Trainer shift</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.trainer_name && shiftTiming ? `${shiftTiming}` : ""}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Trainer last checked-in</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.trainer_name && userData?.assigned_to_last_checkin
                ? formatDateTimezon(userData.assigned_to_last_checkin)
                : "-"}{" "}
              {userData?.trainer_name && userData?.assigned_to_checkin_time
                ? convertTime(userData.assigned_to_checkin_time)
                : ""}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">handover status</p>
          </div>
          <div className="user-details-info">
            <p
              className="info-name"
              style={{
                background:
                  userData?.handover_status === "handover_converted"
                    ? "#E2EFD5"
                    : userData?.handover_status === "completed" ||
                      userData?.handover_status === "handover_completed"
                    ? "#FFEDC0"
                    : "#F3DADA",
                color:
                  userData?.handover_status === "converted"
                    ? "#379C00"
                    : userData?.handover_status === "completed" ||
                      userData?.handover_status === "handover_completed"
                    ? "#171717"
                    : "#D90000",
                padding: "10px",
                borderRadius: "16px",
              }}
            >
              {userData?.handover_status?.replace(/_/g, " ") || "-"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">trial status</p>
          </div>
          <div className="user-details-info">
            <p
              className="info-name"
              style={{
                background:
                  userData?.trial_status === "converted"
                    ? "#E2EFD5"
                    : userData?.trial_status === "completed"
                    ? "#FFEDC0"
                    : "#F3DADA",
                color:
                  userData?.trial_status === "converted"
                    ? "#379C00"
                    : userData?.trial_status === "completed"
                    ? "#171717"
                    : "#D90000",
                padding: "10px",
                borderRadius: "16px",
              }}
            >
              {userData?.trial_status === "completed"
                ? "Completed (Not Converted)"
                : userData?.trial_status === "trial_done_cnvrtd"
                ? "PT consultation done And Converted"
                : userData?.trial_status === "trial_notdone_cnvrtd"
                ? "PT consultation not done And Converted"
                : userData.trial_status?.replace(/_/g, " ") || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Member Profession</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.profession?.replace(/_/g, " ") || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Subscription Added By</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.sub_added_by_name || "NA"}</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Current Plan Name</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.current_plan_name?.replace(/_/g, " ") || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Current Plan Duration</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              <b>
                {userData?.regular_start_date
                  ? formatDateTimezon(userData.regular_start_date)
                  : "-"}
              </b>{" "}
              TO{" "}
              <b>
                {userData?.regular_expire_date
                  ? formatDateTimezon(userData.regular_expire_date)
                  : "-"}
              </b>
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Payment Location</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.payment_location === "gym"
                ? "Inside Gym"
                : userData?.payment_location === "outside"
                ? "Outside Gym"
                : "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member Current Plan status</p>
          </div>
          <div className="user-details-info">
            <p
              className="info-name"
              style={{
                background:
                  userData?.current_plan_status === "active"
                    ? "#E2EFD5"
                    : "#F3DADA",
                color:
                  userData?.current_plan_status === "active"
                    ? "#379C00"
                    : "#D90000",
                padding: "10px",
                borderRadius: "16px",
              }}
            >
              {userData?.current_plan_status || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member diet preference</p>
          </div>
          <div className="user-details-info">
            <p
              className="info-name"
              style={{
                background:
                  userData?.diet_preference === "vegetarian"
                    ? "#E2EFD5"
                    : userData?.diet_preference === "eggetarian"
                    ? "#FFEDC0"
                    : "#F3DADA",
                color:
                  userData?.diet_preference === "vegetarian"
                    ? "#379C00"
                    : userData?.diet_preference === "eggetarian"
                    ? "#171717"
                    : "#D90000",
                padding: "10px",
                borderRadius: "16px",
              }}
            >
              {userData?.diet_preference?.replace(/_/g, " ") || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">member goal(s)</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.user_goal?.replace(/_/g, " ") || "NA"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">how active</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.how_active?.replace(/_/g, " ") || "-"}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">medical history</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">{userData?.medical_history || "-"}</p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Handover Date</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.assigned_date
                ? formatDateTimezon(userData.assigned_date)
                : "-"}{" "}
              {userData?.assigned_date_days_ago
                ? `(${userData.assigned_date_days_ago?.replace(/_/g, " ")})`
                : ""}{" "}
              by {userData?.assigned_by_name || "NA"}{" "}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">PT schedule date</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.pt_schedule_date
                ? convertStraight(userData.pt_schedule_date)
                : "-"}{" "}
              by {userData?.assigned_by_name || "NA"}{" "}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">PT Trial Date</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.pt_initiate_date
                ? convertStraight(userData.pt_initiate_date)
                : "-"}{" "}
              {userData?.pt_initiate_date_days_ago
                ? `(${userData.pt_initiate_date_days_ago?.replace(/_/g, " ")})`
                : ""}{" "}
              by {userData?.assigned_to_name || "NA"}{" "}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">3 Day PT Trial</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {userData?.three_day_assigned ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-check-circle-fill"
                  viewBox="0 0 16 16"
                  style={{
                    color: "#209216",
                    width: "35px",
                    height: "35px",
                  }}
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-x-circle-fill"
                  viewBox="0 0 16 16"
                  style={{ color: "#E41815", width: "35px", height: "35px" }}
                >
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                </svg>
              )}{" "}
              {userData?.threeday_start_date
                ? convertStraight(userData.threeday_start_date)
                : "-"}
              {" - "}
              {userData?.threeday_expire_date
                ? convertStraight(userData.threeday_expire_date)
                : "-"}{" "}
              {(userData?.threeday_slot_start ||
                userData?.threeday_slot_end) && (
                <small>
                  (
                  <b>
                    {userData?.threeday_slot_start
                      ? convertTo12HourFormat(userData.threeday_slot_start)
                      : "-"}
                  </b>{" "}
                  -{" "}
                  <b>
                    {userData?.threeday_slot_end
                      ? convertTo12HourFormat(userData.threeday_slot_end)
                      : "-"}
                  </b>
                  )
                </small>
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">PT Prospect</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {!userData?.is_pt_prspct && userData?.pt_prspct_reason ? (
                <>{userData.pt_prspct_reason || "NA"}</>
              ) : (
                <>
                  ₹{convertThenFormat(userData?.prspct_value || 0)}{" "}
                  {userData?.prspct_session && userData?.prspct_duration
                    ? `(${userData.prspct_session} for ${userData.prspct_duration} days)`
                    : null}
                  <br />
                  {userData?.expctd_closure_date
                    ? convertStraight(userData.expctd_closure_date)
                    : ""}{" "}
                  (Closure Date)
                  <br />
                  {type ? (
                    <b
                      style={{
                        color:
                          type === "hot"
                            ? "#0A6847"
                            : type === "semi hot"
                            ? "#D9610B"
                            : type === "warm"
                            ? "#D78B03"
                            : type === "cold"
                            ? "#157EF9"
                            : "",
                      }}
                    >
                      {type === "closed_not_cnvrtd"
                        ? "Closed and not converted"
                        : type === "closed_cnvrtd_prspct"
                        ? "Closed and converted"
                        : type === "not_specified_prspct"
                        ? "Prospect Not Specified"
                        : type?.replace(/_/g, " ")}
                    </b>
                  ) : (
                    ""
                  )}
                </>
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">1 Minute Run Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_RUN_TEST, userData?.min_run_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Push-Up Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_PUSHUP_TEST, userData?.push_up_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Plank Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_PLANK_TEST, userData?.plank_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Wall Sit Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_PLANK_TEST, userData?.wall_sit_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">In-Line Lunge Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_INLINE_LUNGE__TEST, userData?.lunge_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Shoulder Flexion Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(
                PT_TRIAL_SHOULDER_FLEXION_TEST,
                userData?.shoulder_flex_test
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Shoulder Extension Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(
                PT_TRIAL_SHOULDER_EXTENSION_TEST,
                userData?.shoulder_extn_test
              )}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Leg Raise Angle</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_LEG_RAISE_TEST, userData?.leg_raise_angle)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Thomas Test</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(PT_TRIAL_THOMAS_TEST, userData?.thomas_test)}
            </p>
          </div>
        </div>

        <div className="user-details">
          <div className="user-details-head">
            <p className="head-name">Overall Fitness Rating</p>
          </div>
          <div className="user-details-info">
            <p className="info-name">
              {getTestLabel(
                PT_TRIAL_OVERALL_FITNESS_RATING,
                userData?.overall_fitness
              )}
            </p>
          </div>
        </div> */}
        </>
      </div>
    </div>
  );
};

export default UserProfile;
